import { render } from "./CampaignsCreate.vue?vue&type=template&id=5a748649"
import script from "./CampaignsCreate.vue?vue&type=script&lang=js"
export * from "./CampaignsCreate.vue?vue&type=script&lang=js"

import "./CampaignsCreate.vue?vue&type=style&index=0&id=5a748649&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__